/*
 * @Author: your name
 * @Date: 2020-08-10 10:25:18
 * @LastEditTime: 2020-08-14 01:45:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /intelligent-parking/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import axios from 'axios'
import Util from './Util'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '19161b879b8e9b6b4dcebde98e34c269', // 自己到官网申请，我随便写的
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation','Geocoder'],//plugin所要用到的模块功能，按需添加
  v: '1.4.4',//高德 sdk 版本为 1.4.4
});

Vue.use(Element)
Vue.prototype.$http = axios
Vue.config.productionTip = false
let loading = null

axios.defaults.timeout = 30000

axios.interceptors.request.use(config => {
    let num = Math.random() * Math.random()
    let token = Util.getCookie('token')
    if (token) {
        config.headers.token = token
        axios.defaults.headers.common['token'] = token
    }
    config.headers.no_commit = num

    config.headers.req_from = "parking-admin"
    // if (config.method == 'post') {
    //     loading = Element.Loading.service({
    //         lock: true,
    //         text: 'Loading',
    //         spinner: 'el-icon-loading',
    //         background: 'rgba(0, 0, 0, 0.3)'
    //     })
    // }

    return config
}, err => {
    // closeLoading()
    return Promise.reject(err)
})

axios.interceptors.response.use(
    response => {
        if (response.data.code == 401) {
            // Util.message("err", response.data.desc);
            Util.delCookie('token')
            location.href = '/Login'
        }
        // if (reqArr.length === 1) {
        //   closeLoading()
        // }
        // reqArr.pop()

        // const body = response.data

        if (loading) {
            loading.close()
        }

        return response
    },
    error => {
        if (loading) {
            loading.close()
        }
        if (error.response) {
            if (error.response.data.code == 401) {
                Util.message("err", error.response.data.desc);
                Util.delCookie('token')
                location.href = '/Login'
            } else {
                // Element.Notification.error('网络错误')
            }
        } else {
            // Element.Notification.error('其他错误')
        }

        // return Promise.resolve(error.response)
    }
)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js